import { GetterTree } from "vuex";

import { DocumentState, DocumentType } from "../types";

const getters: GetterTree<DocumentState, any> = {
  getCountry: (state) => state.country,
  getCountryCode: (state) => state.countryCode,
  getDocumentType: (state) => state.documentType,
  isPassportSupported: (state) =>
    state.supportedDocuments.filter((doc) => doc.type === DocumentType.PASSPORT)
      .length > 0,
  isNationalIdSupported: (state) =>
    state.supportedDocuments.filter(
      (doc) => doc.type === DocumentType.NATIONALID
    ).length > 0,
  isDriversLicenseSupported: (state) =>
    state.supportedDocuments.filter(
      (doc) => doc.type === DocumentType.DRIVERSLICENSE
    ).length > 0,
};

export default getters;
